<template><div><h1 id="eb-mandanten-buchungskontrolle" tabindex="-1"><a class="header-anchor" href="#eb-mandanten-buchungskontrolle"><span>EB-Mandanten-Buchungskontrolle</span></a></h1>
<p>EB-Mandanten-Buchungskontrolle — Die Auswertung überprüft, ob für alle Mandanten die Fakturen ausgeglichen sind</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Statistik kontrolliert alle Fakturen, die zum Datum [bis Datum] ausgeglichen sind und auch den übrigen Parametern entsprechen, ob bei diesen die Mandanten korrekt benutzt wurden. Das bedeutet, die Auswertung überprüft, ob für alle Mandanten die Fakturen ausgeglichen sind. Alle problematischen Fakturen (Einzelbuchungen) werden angezeigt.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → EB-Kontoauszüge → EB-Mandanten-Buchungskontrolle</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<ul>
<li>
<p>von Personen-ID:
: ? = 0 (inklusive)</p>
</li>
<li>
<p>bis:
: ? = 99999999 (Personen-ID, inklusive)Wenn nur ein Feld ausgefüllt ist und das andere ? zeigt, dann wird nur diese Personen-ID ausgewertet</p>
</li>
<li>
<p>von Journalnummer:
: ? = von unten unbegrenzt (inklusive)</p>
</li>
<li>
<p>bis:
: ? = von oben unbegrenzt (Journalnummer, inklusive)</p>
</li>
<li>
<p>von Datum:
: ? = von unten unbegrenzt (inklusive)</p>
</li>
<li>
<p>bis:
: ? = von oben unbegrenzt (Datum, inklusive)</p>
</li>
<li>
<p>Liste Nr:
: [Liste Nr] = 7; kann 1 - 7 sein, aber 1 - 6 sind nicht mehr aktuell</p>
</li>
<li>
<p>Mandanten:
: [Mandant] eingeben. * zeigt alle Mandanten an, die in der Auswertung vorkommen.</p>
</li>
<li>
<p>nur mit Merkmal:
: leer = alle, sonst läuft Auswertung nur für jene Adressen, die das eingegebene Merkmal haben</p>
</li>
</ul>
<dl>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
<dt>Bildschirm:</dt>
<dd>ja</dd>
<dt>Drucker/Format:</dt>
<dd>A4 hoch</dd>
<dt>Hintergrundverarb.:</dt>
<dd>ja</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>- Name:</td>
<td>Adressname</td>
</tr>
<tr>
<td>- Adresse:</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>- FaktNum:</td>
<td>Fakturanummer</td>
</tr>
<tr>
<td>- M:</td>
<td>Mandant</td>
</tr>
<tr>
<td>- T:</td>
<td>Einzelbuchungstyp</td>
</tr>
<tr>
<td>- Datum:</td>
<td>Buchungsdatum der Einzelbuchung</td>
</tr>
<tr>
<td>- Total/Typ:</td>
<td>kumulierter Betrag pro Einzelbuchungstyp, Mandant und Faktura</td>
</tr>
<tr>
<td>- Total/Mand:</td>
<td>kumulierter Betrag pro Mandant und Faktura</td>
</tr>
<tr>
<td>Rekapitulation pro Mandant:</td>
<td>Rekapitulation pro Mandant:</td>
</tr>
<tr>
<td>- M:</td>
<td>Mandant</td>
</tr>
<tr>
<td>- Bezeichnung:</td>
<td>Bezeichnung des Mandanten</td>
</tr>
<tr>
<td>- T:</td>
<td>Einzelbuchungstyp</td>
</tr>
<tr>
<td>- Total/Typ:</td>
<td>Summe pro Einzelbuchungstyp</td>
</tr>
<tr>
<td>- Total/Mandant:</td>
<td>Summe pro Mandant</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                                11.11.1998 14:32:27 mop  Seite     0</span>
<span class="line"> </span>
<span class="line"></span>
<span class="line">                           EB-Mandanten-Konsolidation</span>
<span class="line"></span>
<span class="line">                 von Personen-ID.: 0          bis: 99,999,999</span>
<span class="line">                 von Journalnummer: ?          bis: |</span>
<span class="line">                 von Datum........:            bis:</span>
<span class="line"></span>
<span class="line">                 Liste Nr.........: 7</span>
<span class="line">                 Mandanten........: \*</span>
<span class="line">                 nur mit Merkmal..:</span>
<span class="line"></span>
<span class="line"> Name           Adresse FaktNum M T  Datum         Total/Typ     Total/Mand</span>
<span class="line"> ------------- -------- ------- - -- -------- -------------- --------------</span>
<span class="line"> Boeni Stephan  1796325 1417406 V Z  31.07.98        -517.60        -517.60</span>
<span class="line">                      .       . W A  30.06.94         517.60         517.60</span>
<span class="line">                                                             --------------</span>
<span class="line">                                                                       0.00 Total</span>
<span class="line"> Rekapitulation pro Mandant</span>
<span class="line"> M Bezeichnung                    T       Total/Typ  Total/Mandant</span>
<span class="line"> - ------------------------------ -- -------------- --------------</span>
<span class="line"> V VDZC                           Z         -517.60        -517.60</span>
<span class="line"> W Unbekannter Mandant            A          517.60         517.60</span>
<span class="line">                                                    --------------</span>
<span class="line">                                                              0.00 Total</span>
<span class="line"></span>
<span class="line"></span>
<span class="line"> -------------------------------------------------------------------------------</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Der Kunde Boeni hat einen Auftrag im Mandanten W, die Zahlung im gleichen Betrag wurde aber auf den Mandanten V gebucht. Dies ist in diesem Bericht die einzige Buchung, die bereinigt werden muss.</p>
</div></template>


